import styled, { keyframes } from "styled-components";

const marqueeScroll = (distance: number) => keyframes` 
0% { transform: translateX(0px); } 
100% { transform: translateX(${distance}px); } `;

const enterKeyframes = keyframes`
  0% {
    opacity: 1;
    top:0
        transform: translateX(-50%) translatey(-10px);

  }
    64%{
              opacity: .8;
             transform: translateX(-50%) translatey(354px);



    }
  100% {
               transform: translateX(-50%) translatey(354px);

    opacity: 0;

  }
    
`;
export const AboutUsComponentMainDiv = styled.main``;

export const AboutUsComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 216px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .aboutus-hero-container {
    display: flex;
    flex-flow: column;
    gap: 60px;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-hero-header-container {
    display: flex;
    flex-flow: column;
    gap: 12px;
    width: 100%;
    flex: 1;
  }
  .aboutus-hero-header-text-container {
    width: 100%;
    flex: 1;
    max-width: 784px;
  }
  .aboutus-hero-image-container {
    width: 100%;
    flex: 1;
    border: 1px solid black;
    aspect-ratio: 1.66911;
    height: 682px;
    width: 100%;
    position: relative;
    border-radius: 16px;
  }
  .aboutus-info-container {
    grid-template-rows: repeat(1, minmax(0, 1fr));
    grid-template-columns: repeat(3, minmax(50px, 1fr));
    grid-auto-rows: minmax(0, 1fr);
    justify-content: center;
    gap: 24px;
    width: 100%;
    display: grid;
    position: relative;
    overflow: visible;
  }
  .aboutus-info-item-container {
    border: 1px solid #ffffff1a;
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    backdrop-filter: blur(10px);
    background: #ffffff0a;
    display: flex;
  }
  .aboutus-info-item-wrapper {
    width: 100%;
    flex: 1;
    gap: 12px;
  }
  .aboutus-info-top-wrapper {
    display: flex;
    gap: 0;
    align-itms: center;
  }
  .aboutus-info-text-wrapper {
    font-size: 60px;
    font-weight: 500;
    font-family: "General Sans", "General Sans Placeholder", sans-serif;
    line-height: 1.4em;
    > p {
      font-size: 17px;
      opacity: 0.8;
      font-weight: 500;
      line-height: 1.4em;
    }
  }
`;

export const AboutUsComponentValueDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }

  .aboutus-value-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    gap: 60px;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-value-header-container {
    display: flex;
    flex-flow: column;

    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
    flex: 1;
  }
  .aboutus-value-header-text-container {
    width: 100%;
    flex: 1;
    max-width: 784px;
    text-align: center;
  }
  .aboutus-values-container {
    grid-template-rows: repeat(1, minmax(0, 1fr));
    grid-template-columns: repeat(3, minmax(50px, 1fr));
    grid-auto-rows: minmax(0, 1fr);
    justify-content: center;
    gap: 24px;
    width: 100%;
    display: grid;
    position: relative;
    overflow: visible;
  }
  .aboutus-value-item-container {
    border: 1px solid #191919;
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    display: flex;
    place-self: start;
  }
  .aboutus-value-item-wrapper {
    display: flex;
    flex-flow: column;
    gap: 32px;
  }
  .aboutus-value-image-wrapper {
    height: 202px;
    border: 1px solid black;
    border-radius: 8px;
    width: 100%;
  }
  .aboutus-value-text-container {
    display: flex;
    flex-flow: column;
    gap: 16px;
  }
  .aboutus-value-text-wrapper {
    > h3 {
      font-size: 24px;
      line-height: 1.2em;
    }
    > p {
      font-size: 17px;
      line-height: 1.4em;
      font-weight: 400;
      opacity: 0.9;
    }
  }
`;

export const AboutUsComponentTimelineDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }

  .aboutus-timeline-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    gap: 10px;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-timeline-wrapper {
    display: flex;
    align-items: center;
    max-width: 946px;
    flex-flow: column;

    width: 100%;
    flex: 1;
  }

  .aboutus-timeline-line {
    width: 4px;
    height: 100%;
    position: absolute;
    border-right: 0.1px dashed #252525;
    left: 50%;
    left: calc(50% - 1.5px);
    transform: translateX(-50%);
  }
`;

interface AboutUsComponentTimelineItemProp{
  reverse:boolean

}
export const AboutUsComponentTimelineItemDiv = styled.div<AboutUsComponentTimelineItemProp>`
  flex: 1;
  width: 100%;
  height: 935px;
  .aboutus-timeline-item-circle {
    width: 2px;
    position: absolute;
    left: 50%;
    height: 354px;

    transform: translateX(-50%);
    &:after {
      animation: ${enterKeyframes} linear;
      animation-timeline: view();
      animation-range: cover 45% cover 100%;

      content: "";
      border-radius: 100%;
      width: 20px;
      height: 20px;
      position: absolute;
      background: white;
      left: 50%;
      top: 0%;
      opacity: 0;

      transform: translateX(-50%);
    }
  }
  > div {
    flex: 1;
    width: 100%;
  }
  .aboutus-timeline-item-container {
    width: 100%;
    flex: 1;
    padding-bottom: 120px;
  }
  .aboutus-timeline-item-wrapper {
    width: 100%;
    display: flex;
    flex-flow:${(p)=>p.reverse ?" row-reverse":"row" };
    gap: 14px;
    justify-content: space-between;
    align-items: center;
    flex: 1;
  }
  .aboutus-timeline-image-container {
    width: 100%;
    max-width: 383px;
  }
  .aboutus-timeline-image-wrapper {
    border-radius: 8px;
    height: 234px;
    border: 1px soli black;
  }
  .aboutus-timeline-text-container {
    width: 100%;
    display: flex;
    gap: 8px;
    flex-flow: column;
    max-width: 383px;
  }
  .aboutus-timeline-text-wrapper {
    > p {
      line-height: 1.4em;
      font-weight: 400;
      opacity: 0.9;
    }
    > h4 {
      font-size: 32px;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
      font-weight: 500;
      line-height: 1.1em;
    }
  }
`;

export const AboutUsComponentTrustedDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .aboutus-trusted-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    gap: 60px;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-trusted-header-text-container {
    width: 100%;
    flex: 1;
    max-width: 799px;
    display: flex;
    flex-flow: column;
    gap: 16px;
    align-items: center;

    text-align: center;
  }
  .aboutus-trusted-header-text-wrapper {
    width: 100%;
    flex: 1;
    max-width: 799px;

    text-align: center;
  }
  .aboutus-trusted-image-container {
    width: 100%;
    flex: 1;
    flex-wrap: wrap;
    place-content: center;
    align-items: center;
    gap: 40px;
    width: 100%;
    display: flex;
    position: relative;
  }
  .aboutus-trusted-item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #808080;
  }
  .aboutus-trusted-icon {
    width: 48px;
    height: 48px;
    color: #808080;
    fill: #808080;
  }
  .aboutus-trusted-text {
    > div {
      > p {
        font-size: 32px;
        padding: 0;
        font-family: "Inter", "Inter Placeholder", sans-serif;

        font-weight: 700;
        text-transform: capitalize;
        margin: 0;
        color: #808080;
      }
    }
  }
`;

export const AboutUsComponentTeamDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .aboutus-team-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    gap: 60px;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-team-header-text-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 16px;
    align-items: center;

    text-align: center;
  }
  .aboutus-team-header-text-wrapper {
    width: 100%;
    flex: 1;
    max-width: 749px;

    text-align: center;
    > h2 {
      font-weight: 500;
      font-size: 64px;
    }
  }
  .aboutus-team-body-container {
    background-color: #000;
    flex: none;
    grid-template-rows: repeat(1, min-content);
    grid-template-columns: repeat(3, minmax(50px, 1fr));
    grid-auto-rows: min-content;
    justify-content: center;
    gap: 30px;
    width: 100%;
    height: min-content;
    display: grid;
  }
  .aboutus-team-item-container {
    border-radius: 16px;
    width: 100%;
    display: flex;
    gap: 16px;
    flex-flow: column;
  }
  .aboutus-team-image-wrapper {
    aspect-ratio: 1.0997;
    border-radius: 16px;
    border: 1px solid red;
    height: 331px;
    flex: 1;
    width: 100%;
  }
  .aboutus-team-bottom-container {
    display: flex;
    flex: 1;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
  }
  .aboutus-team-text-container {
    display: flex;
    flex: 1;
    width: 100%;
    flex-flow: column;
  }
  .aboutus-team-icon-container {
    width: 28px;
    height: 28px;
  }
  .aboutus-team-icon-wrapper {
    width: 28px;
    color: white;
    height: 28px;
    > svg {
      width: 28px;
      color: white;
      height: 28px;
      fill: white;
    }
  }
  .aboutus-team-text-wrapper {
    > h4 {
      font-size: 24px;
      font-weight: 500;
      line-height: 1.5em;
    }
    > p {
      opacity: 0.7;
      line-height: 1.4em;
    }
  }
`;

export const AboutUsComponentTeamCultureDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .aboutus-team-culture-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    gap: 60px;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-team-culture-header-text-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 16px;
  }

  .aboutus-team-culture-header-text-wrapper {
    width: 100%;
    flex: 1;
    max-width: 769px;

    > h2 {
      font-weight: 500;
      font-size: 64px;
    }
  }
`;

interface AboutUsComponentTeamCultureItemProp {
  length: number;
  itemwidth: number;
  gap: number;
}
export const AboutUsComponentTeamCultureItemSection = styled.div<AboutUsComponentTeamCultureItemProp>`
  width: 100%;
  flex: 1;
  .aboutus-team-culture-section-container {
    flex-flow: row;
    align-items: center;
    gap: 0;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    height: min-content;
    display: flex;
    position: relative;
    overflow: visible;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }

  .aboutus-team-culture-section-holder {
    flex-flow: column;
    flex: 1 0 0;
    place-content: center;
    align-items: center;
    gap: 32px;
    width: 1px;
    max-width: 1140px;
    height: min-content;

    padding: 0;
    display: flex;
    position: relative;
    overflow: hidden;
    > div {
      display: flex;
      width: 100%;
      flex: 1;
    }
  }
  .aboutus-team-culture-marque-container {
    width: 100%;
    cursor: pointer;
    position:relative > div {
      flex-flow: row;
      place-content: center;
      align-items: center;
      gap: 0;
      width: 100%;
      height: min-content;
      padding: 0;
      display: flex;
      position: relative;
      overflow: visible;
    }
    .aboutus-team-culture-marque-gradient-cover {
      width: 60px;
      position: absolute;
      top: 0;
      z-index: 1;
      bottom: 0;
    }
    .aboutus-team-culture-marque-gradient-cover-left {
      left: 0;
      background: linear-gradient(
        90deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }
    .aboutus-team-culture-marque-gradient-cover-right {
      right: 0;
      background: linear-gradient(
        270deg,
        rgb(0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      );
    }

    .aboutus-team-culture-marque-scroll-holder {
      flex: 1 0 0;
      width: 1px;
      height: min-content;
      position: relative;
      padding: 4px > section {
        display: flex;
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        place-items: center;
        margin: 0px;
        padding: 0px;
        list-style-type: none;
        opacity: 1;
        overflow: hidden;
      }
    }
    .aboutus-team-culture-marque-scroll-list {
      list-style-type: none;
      display: flex;
      width: 100%;
      height: 100%;
      max-width: 100%;
      max-height: 100%;
      align-items: center;
      margin: 0px;
      padding: 0px;
      gap: 30px;
      position: relative;
      flex-direction: row;
      transform: translateX(
        ${(p) => (p.gap * p.length + p.itemwidth * p.length) * -1}px
      );
      animation: ${({ gap, length, itemwidth }) =>
          marqueeScroll((gap * length + itemwidth * length) * -1)}
        20s linear infinite;
      &:hover {
        animation-play-state: paused;
      }
    }
  }
`;

export const AboutUsComponentTeamCultureItemDiv = styled.div`
  .aboutus-team-culture-icon {
    width: 652px;
    height: 435px;
    border-radius: 16px;
    border: 1px solid red;
  }
`;

export const AboutUsComponentCareersDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .aboutus-careers-container {
    display: flex;
    gap: 60px;
    justify-content: space-between;
    max-width: 1140px;
    width: 100%;
    flex: 1;
  }
  .aboutus-careers-left-container {
    width: 100%;
    max-width: 441px;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 24px;
  }
  .aboutus-careers-header-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 12px;
  }
  .aboutus-careers-header-text-wrapper {
    > p {
      font-size: 16px;
      font-weight: 400;
      opacity: 0.9;
      line-height: 1.5em;
    }
    > h4 {
      font-size: 20px;
      font-weight: 500;
      line-height: 1.6em;
    }
  }

  .aboutus-careers-bottom-text-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: column;
    gap: 40px;
  }

  .aboutus-careers-button-container {
    display: flex;
    max-width: 160px;
  }
  .aboutus-careers-right-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow:column;
    gap: 24px;
  }
  .aboutus-careers-item {
    width: 100%;
    height:min-content;
    flex: 1;
    display: flex;
    gap: 24px;
    border: 1px solid #191919;
    padding: 24px;
    border-radius: 16px;
    justify-content: space-between;
    align-items: center;
  }
  .aboutus-careers-item-text-container {
    width: 100%;
    max-width: 344px;
    flex: 1;
    display: flex;
    gap: 16px;
    flex-flow: column;
  }
  .aboutus-careers-item-text-wrapper {
              text-transform:capitalize;

    > h3 {
      font-size: 24px;
      line-height: 1.5em;
      font-weight: 500;
    }
      >p{
            font-size: 18px;
            text-transform:capitalize;

      }
  }
      .aboutus-careers-item-details-container {
    display: flex;
    gap: 24px;
  }
  .aboutus-careers-item-details-wrapper {
    display: flex;
    gap: 8px;
    opacity: 0.6;
  }
  .aboutus-careers-item-icon-wrapper {
    width: 20px;
    height: 20px;
    color: white;

    > svg {
      width: 20px;
      height: 20px;
      fill: white;
      color: white;
    }
  }
`;
